import React from "react";
import "./NotFound.css"
import { Link } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import { useContext } from "react";

const NotFound = () => {
    const { language } = useContext(LanguageContext);
    return (

        <div className="not-found-section">
            <div className="not-found-img">
                <span class="material-symbols-outlined notraslate">
                    sentiment_stressed
                </span>
            </div>
            <div className="not-found-title">
                Not Found
            </div>
            <div className="not-found-content">
                Don't be mad! The page you were looking for was not found but you can always go back home!
            </div>
            <Link to={`/${language?.value || 'es'}/`} className="link-to-home" > Take me out from here! </Link>
        </div>


    );

}
export default NotFound;
